import React from 'react';
import { Alert, Box } from '@mui/material';
import { format, utcToZonedTime } from 'date-fns-tz';
import PropTypes from 'prop-types';

const TIMEZONE = 'Europe/Moscow';
const DATE_FORMAT = 'dd.MM.yyyy HH:mm';

const formatInTimezone = (date) => {
  const zonedDate = utcToZonedTime(date, TIMEZONE);
  return `${format(zonedDate, DATE_FORMAT, { timeZone: TIMEZONE })} MSK`;
};

function MaintenanceBanner({ start, until, isActive }) {
  const message = isActive
    ? `В период с ${formatInTimezone(start)} по ${formatInTimezone(until)} производится техническое обслуживание платформы. Просим учитывать данный интервал в своей работе.`
    : `В период с ${formatInTimezone(start)} по ${formatInTimezone(until)} будет производиться техническое обслуживание платформы. Просим учитывать данный интервал в своей работе.`;

  return (
    <Box sx={{ mb: 2, width: '100%' }}>
      <Alert severity="warning" sx={{ '& .MuiAlert-message': { width: '100%' } }}>
        {message}
      </Alert>
    </Box>
  );
}

MaintenanceBanner.propTypes = {
  start: PropTypes.instanceOf(Date).isRequired,
  until: PropTypes.instanceOf(Date).isRequired,
  isActive: PropTypes.bool.isRequired,
};

export default MaintenanceBanner;